
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import AudioButton from '../AudioButton/AudioButton';
import FullscreenButton from '../FullscreenButton/FullscreenButton';
import classes from './OptionsBlock.module.css';

const OptionsBlock = ({in_game}) => {

  return (
    <div className={clsx(classes.OptionsBlock, in_game && classes.inGame)}>
     <AudioButton />
     <FullscreenButton />
    </div>
  );
};

export default observer(OptionsBlock);
